"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactLoading = require("react-loading");

var _reactLoading2 = _interopRequireDefault(_reactLoading);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _baseHelper = require("../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

var _gallery = require("./gallery");

var _gallery2 = _interopRequireDefault(_gallery);

var _galleryHeader = require("./galleryHeader");

var _galleryHeader2 = _interopRequireDefault(_galleryHeader);

var _styled = require("./styled.gallery");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var ProductList = function ProductList(props) {
  var _ref = props || {},
      _ref$config = _ref.config,
      config = _ref$config === undefined ? {} : _ref$config,
      _ref$match = _ref.match,
      match = _ref$match === undefined ? {} : _ref$match,
      _ref$history = _ref.history,
      history = _ref$history === undefined ? {} : _ref$history,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      role = _ref.role;

  var apiURL = config.apiURL;


  var queryParams = history.location && history.location.search || "";

  var url = match.url,
      params = match.params;

  var _ref2 = params.brandName && params.shop ? params : props,
      brandName = _ref2.brandName,
      shop = _ref2.shop;

  var urlString = window.name;
  var parentURL = _baseHelper2.default.isValidURL(urlString) ? urlString : "";

  var uri = apiURL + "/public/brand/" + shop + "/" + brandName;

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      productsList = _useState4[0],
      setProductList = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = _slicedToArray(_useState5, 2),
      searchValue = _useState6[0],
      setSearchValue = _useState6[1];

  var _useState7 = (0, _react.useState)({
    sort_name: "",
    sort_order: ""
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      sortValue = _useState8[0],
      setSortValue = _useState8[1];

  var _useState9 = (0, _react.useState)(1),
      _useState10 = _slicedToArray(_useState9, 2),
      currentPage = _useState10[0],
      setCurrentPage = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      productLoading = _useState12[0],
      setProductLoading = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      userLoading = _useState14[0],
      setUserLoading = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      error = _useState16[0],
      setError = _useState16[1];

  var setQueryParams = function setQueryParams(params) {
    var location = history.location;

    var search = _baseHelper2.default.getQueryParams(location, params);
    history.push(location.pathname + "?" + search);
  };

  var unsetQueryParams = function unsetQueryParams(key) {
    var location = history.location;
    var search = location.search;

    var paramSearch = search.indexOf(key);

    if (paramSearch > -1) {
      var updateUrl = _baseHelper2.default.removeQueryParams(location, key);
      history.push("" + updateUrl);
    }

    setCurrentPage(1);
  };

  var handleSortValueChange = function handleSortValueChange(name, order) {
    setSortValue({ sort_name: name, sort_order: order });
    var sortQueryParams = { sort_name: name, sort_order: order };
    setQueryParams(sortQueryParams);
  };

  var handleSearchChange = function handleSearchChange(e) {
    var searchedValue = e.target.value;
    setSearchValue(searchedValue);
    var searchQueryParams = { search: searchedValue };
    unsetQueryParams("page");
    setQueryParams(searchQueryParams);
  };

  var handleCurrentPageValue = function handleCurrentPageValue(key) {
    var pageValue = currentPage;
    if (key === "previous") {
      pageValue -= 1;
    }

    if (key === "next") {
      pageValue += 1;
    }
    setCurrentPage(pageValue);
    var pageQueryParams = { page: pageValue };
    if (pageValue === 1) {
      history.push("" + url);
      return;
    }
    setQueryParams(pageQueryParams);
  };

  var fetchProductDetails = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var getProductUrl, requestParams, options, response, _ref4, _ref4$products, products, productCount;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setProductLoading(true);
              _context.prev = 1;
              getProductUrl = apiURL + "/public/brand/product/" + shop + "/" + brandName + decodeURIComponent(queryParams);
              requestParams = { uri: getProductUrl };
              options = _baseHelper2.default.getRequestOptions(requestParams, config);
              _context.next = 7;
              return (0, _axios2.default)(options);

            case 7:
              response = _context.sent;

              if (response.data && response.data.status === "ok") {
                _ref4 = response.data.data || response.data, _ref4$products = _ref4.products, products = _ref4$products === undefined ? [] : _ref4$products, productCount = _ref4.productCount;

                setProductList(_extends({}, productsList, {
                  products: products,
                  search: productCount,
                  productCount: productCount
                }));
              }
              setProductLoading(false);
              _context.next = 16;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](1);

              console.error("Error is:", _context.t0.message);
              setProductLoading(false);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined, [[1, 12]]);
    }));

    return function fetchProductDetails() {
      return _ref3.apply(this, arguments);
    };
  }();

  var getUserDetails = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(updateUrl) {
      var requestParams, options, response, _ref6, user, productCount, orderCount, _ref6$brandDetail, brandDetail, _url, _ref6$store, store, temp;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setUserLoading(true);
              _context2.prev = 1;
              requestParams = { uri: updateUrl };
              options = _baseHelper2.default.getRequestOptions(requestParams, config);
              _context2.next = 6;
              return (0, _axios2.default)(options);

            case 6:
              response = _context2.sent;


              if (response.data && response.data.status === "ok") {
                _ref6 = response.data.data || response.data, user = _ref6.user, productCount = _ref6.productCount, orderCount = _ref6.orderCount, _ref6$brandDetail = _ref6.brandDetail, brandDetail = _ref6$brandDetail === undefined ? {} : _ref6$brandDetail, _url = _ref6.url, _ref6$store = _ref6.store, store = _ref6$store === undefined ? {} : _ref6$store;
                temp = _extends({}, state, {
                  user: user,
                  productCount: productCount,
                  orderCount: orderCount,
                  brandDetail: brandDetail,
                  url: _url,
                  store: store
                });

                setState(temp);
                fetchProductDetails();
              }

              setUserLoading(false);
              _context2.next = 16;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](1);

              console.error("Error is: ", _context2.t0.message);
              setError(true);
              setUserLoading(false);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, undefined, [[1, 11]]);
    }));

    return function getUserDetails(_x) {
      return _ref5.apply(this, arguments);
    };
  }();

  var getQueryParamsArray = function getQueryParamsArray(params) {
    var paramObj = _baseHelper2.default.splitQueryParams(params);
    if (paramObj && paramObj.search) {
      setSearchValue(paramObj.search);
    }
  };

  (0, _react.useEffect)(function () {
    if (brandName) {
      getUserDetails(uri);
    }
  }, [brandName]);

  (0, _react.useEffect)(function () {
    if (sortValue || searchValue || currentPage) {
      fetchProductDetails();
    }
    if (queryParams) {
      getQueryParamsArray(queryParams);
    }
  }, [sortValue, searchValue, currentPage, queryParams]);

  var productSpinner = function productSpinner() {
    return _react2.default.createElement(_reactLoading2.default, { className: "productPageSpinner", type: "spin", color: "#999" });
  };

  var barCSS = {
    style: {
      barBackground: style.barBackground,
      searchBackground: style.searchBackground,
      searchBorderRadius: style.searchBorderRadius
    }
  };

  var galleryCSS = {
    style: {
      background: style.background
    }
  };

  return _react2.default.createElement(
    _styled.Wrapper,
    { className: "gallery-bg" },
    _react2.default.createElement(_galleryHeader2.default, {
      className: "margin-top",
      handleSortValueChange: handleSortValueChange,
      searchValue: searchValue,
      handleSearchChange: handleSearchChange,
      productCount: productsList.productCount,
      barCSS: barCSS
    }),
    (productLoading || userLoading) && productSpinner() || _react2.default.createElement(_gallery2.default, {
      galleryCSS: galleryCSS,
      parentURL: parentURL,
      products: productsList.products,
      productCount: productsList.search,
      currentPage: currentPage,
      role: role,
      store: state.store,
      handleCurrentPageValue: handleCurrentPageValue,
      error: error
    })
  );
};

exports.default = ProductList;